import config from 'src/config.json'

export const environment = {
  version: '0.0.0',
  url: config.appUrl,
  production: true,
  options: {
    headerScrollTop : 80,
    headerFluid : false
  },
  mapbox: {
    accessToken: 'pk.eyJ1IjoiaW5vdmVyIiwiYSI6ImNqeTdoNmJkNzAwZW4zaXFmYzI5c3Foam8ifQ.RqMKtMZkpemXqRN4oLdDog' 
  }
};
